// Quote refusals describe input shape, never attachment contents or URLs.
import { FILE_TYPES } from '../company-workspace/data/business-file-types.mjs';
const mediaTypes = new Set([...FILE_TYPES, 'image/png', 'image/jpeg', 'image/gif', 'image/webp']);
const diagnostics = new WeakMap();
const reasons = new Set([
  'invalid_image',
  'invalid_part',
  'unsupported_part',
  'tool_output_unsupported',
  'request_encoding_invalid',
  'document_size_invalid',
  'document_encoding_invalid',
  'document_mime_mismatch',
  'document_type_unsupported',
  'document_reference_invalid',
  'document_format_invalid',
  'document_model_bound_unavailable',
  'request_bound_unavailable',
  'cache_ttl_unsupported',
  'output_bound_invalid',
  'compaction_bound_unavailable',
]);
// The same English as the UI's chat-error namespace, which shows them in every app language.
export const INPUT_QUOTE_MESSAGE =
  'We couldn’t answer this message. If it has a file attached, try sending it without the file.';
export const TOOL_QUOTE_MESSAGE =
  'This step didn’t run because its cost couldn’t be confirmed in advance. Try another source.';

export function usageQuoteError(reason, { tool = false, imageReason } = {}) {
  const code = tool ? 'usage_turn_tool_quote_unavailable' : 'usage_turn_quote_unavailable';
  const error = Object.assign(new Error(code), {
    code,
    statusCode: 402,
    publicMessage: tool ? TOOL_QUOTE_MESSAGE : INPUT_QUOTE_MESSAGE,
    ...(imageReason ? { imageReason } : {}),
  });
  diagnostics.set(
    error,
    Object.freeze({ quoteCode: code, quoteReason: reasons.has(reason) ? reason : 'unknown' }),
  );
  return error;
}

export function withQuotePart(error, part) {
  const prior = diagnostics.get(error);
  if (!prior || prior.quotePartType) return error;
  const types = [
    'text',
    'reasoning',
    'file',
    'image',
    'image-data',
    'image-url',
    'file-data',
    'file-url',
    'tool-call',
    'tool-result',
    'tool-approval-response',
  ];
  const partType = types.includes(part?.type) ? part.type : 'unknown';
  const mediaType = mediaTypes.has(part?.mediaType) ? part.mediaType : 'unknown';
  diagnostics.set(
    error,
    Object.freeze({ ...prior, quotePartType: partType, quoteMediaType: mediaType }),
  );
  return error;
}

export function usageQuoteDiagnostics(error) {
  // The SDK may wrap the actual failure; only our native errors carry metadata.
  for (let current = error, depth = 0; current && depth < 8; current = current.cause, depth++) {
    const result = diagnostics.get(current);
    if (result) return result;
  }
  return {};
}

export function usageQuoteFingerprint(error) {
  const quote = usageQuoteDiagnostics(error);
  return quote.quoteReason
    ? [
        'usage-quote',
        quote.quoteReason,
        quote.quotePartType ?? 'request',
        quote.quoteMediaType ?? 'unknown',
      ]
    : undefined;
}
